import React, { useEffect, useState } from "react";
import { ChevronDown, X } from "lucide-react";
import { crud } from "../lib/api";

function optionLabel(row, labelKeys) {
    for (const k of labelKeys || []) {
        if (row[k]) return String(row[k]);
    }
    return row.username || row.ad || row.baslik || `#${row.id}`;
}

export default function ListFiltersPanel({
    filters = [],
    values = {},
    onChange,
    onApply,
    onClear,
}) {
    const [open, setOpen] = useState(false);
    const [fkOptions, setFkOptions] = useState({});

    useEffect(() => {
        let cancelled = false;
        const fkFields = filters.filter((f) => f.type === "fk" && f.resource);
        if (!fkFields.length) return undefined;

        (async () => {
            const next = {};
            for (const f of fkFields) {
                try {
                    const data = await crud.list(f.resource, {
                        page_size: 200,
                    });
                    const rows = Array.isArray(data)
                        ? data
                        : data.results || [];
                    next[f.key] = rows;
                } catch {
                    next[f.key] = [];
                }
            }
            if (!cancelled) setFkOptions(next);
        })();

        return () => {
            cancelled = true;
        };
    }, [filters]);

    if (!filters.length) return null;

    const inputClass =
        "w-full bg-[#0B0F19] border border-white/10 rounded-md px-3 py-2 text-sm text-slate-100 focus:border-[#D4AF37] focus:ring-1 focus:ring-[#D4AF37] outline-none";

    return (
        <div className="mb-4">
            <button
                type="button"
                data-testid="toggle-advanced-filters"
                onClick={() => setOpen((v) => !v)}
                className="h-9 px-3 rounded-md border border-white/10 text-slate-300 hover:bg-white/5 text-xs inline-flex items-center gap-2"
            >
                <ChevronDown
                    className={`h-3.5 w-3.5 transition-transform ${open ? "" : "-rotate-90"}`}
                />
                Gelişmiş filtre
            </button>

            {open && (
                <div className="mt-3 rounded-lg border border-white/10 bg-[#121A2F] p-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                        {filters.map((f) => (
                            <label key={f.key} className="block">
                                <span className="text-[10px] uppercase tracking-[0.14em] text-slate-500 mb-1 block">
                                    {f.label}
                                </span>
                                {f.type === "select" && (
                                    <select
                                        data-testid={`filter-${f.key}`}
                                        value={values[f.key] ?? ""}
                                        onChange={(e) =>
                                            onChange(f.key, e.target.value)
                                        }
                                        className={inputClass}
                                    >
                                        <option value="">Tümü</option>
                                        {(f.options || []).map((o) => (
                                            <option
                                                key={o.value}
                                                value={o.value}
                                            >
                                                {o.label}
                                            </option>
                                        ))}
                                    </select>
                                )}
                                {f.type === "date" && (
                                    <input
                                        type="date"
                                        data-testid={`filter-${f.key}`}
                                        value={values[f.key] ?? ""}
                                        onChange={(e) =>
                                            onChange(f.key, e.target.value)
                                        }
                                        className={inputClass}
                                    />
                                )}
                                {f.type === "number" && (
                                    <input
                                        type="number"
                                        min="0"
                                        step="any"
                                        data-testid={`filter-${f.key}`}
                                        value={values[f.key] ?? ""}
                                        onChange={(e) =>
                                            onChange(f.key, e.target.value)
                                        }
                                        className={inputClass}
                                        placeholder="0"
                                    />
                                )}
                                {f.type === "fk" && (
                                    <select
                                        data-testid={`filter-${f.key}`}
                                        value={values[f.key] ?? ""}
                                        onChange={(e) =>
                                            onChange(f.key, e.target.value)
                                        }
                                        className={inputClass}
                                    >
                                        <option value="">Tümü</option>
                                        {(fkOptions[f.key] || []).map((row) => (
                                            <option
                                                key={row.id}
                                                value={row.id}
                                            >
                                                {optionLabel(
                                                    row,
                                                    f.labelKeys,
                                                )}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </label>
                        ))}
                    </div>
                    <div className="flex flex-wrap gap-2 mt-4 pt-3 border-t border-white/10">
                        <button
                            type="button"
                            data-testid="apply-advanced-filters"
                            onClick={onApply}
                            className="h-9 px-4 rounded-md btn-gold text-xs"
                        >
                            Filtreleri uygula
                        </button>
                        <button
                            type="button"
                            data-testid="clear-advanced-filters"
                            onClick={onClear}
                            className="h-9 px-3 rounded-md border border-white/10 text-slate-400 hover:text-white text-xs inline-flex items-center gap-1"
                        >
                            <X className="h-3.5 w-3.5" />
                            Temizle
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
